module.exports = __webpack_public_path__ + "static/media/internet.1df61191.jpg";